export enum LoaderMode {
    Determinate = 'determinate',
    Indeterminate = 'inderterminate',
}
